import { ResolveFn } from '@angular/router';
import {MapLayerService} from "./map-layer.service";
import {inject} from "@angular/core";
import {MapLayer} from "./map-layer.model";

export const mapLayerResolver: ResolveFn<Promise<MapLayer[]>> = (route, state) => {
  const mapLayerService: MapLayerService = inject(MapLayerService)
  return mapLayerService.fetch()
};
